import { defineNuxtPlugin } from '#app/nuxt'
import { LazyButton, LazyInputNumber, LazyInputText, LazyInputTextArea, LazyParagraphComponent, LazyVueLenis, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["Button", LazyButton],
["InputNumber", LazyInputNumber],
["InputText", LazyInputText],
["InputTextArea", LazyInputTextArea],
["ParagraphComponent", LazyParagraphComponent],
["VueLenis", LazyVueLenis],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
